import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';
import type * as lazyIndex from './lazyIndex';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HybridspacePlaceMapView" */ './lazyIndex'),
    { name: 'HybridspacePlaceMapView' }
);
export const HybridspacePlaceMapView: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.HybridspacePlaceMapView
);
